import {
  WsIconError,
  WsIconInfoFill,
  WsIconSuccess,
  WsIconWarning,
} from '@ws/wsicons-vue'

import { buildProps } from '@element-plus/utils'
import icon400 from './icon/icon-400.vue'
import icon403 from './icon/icon-403.vue'
import icon404 from './icon/icon-404.vue'
import icon500 from './icon/icon-500.vue'
import icon502 from './icon/icon-502.vue'
import iconExpiration from './icon/icon-expiration.vue'
import iconNoOpen from './icon/icon-no-open.vue'
import iconUpgrade from './icon/icon-upgrade.vue'

import type { Component, ExtractPropTypes } from 'vue'
import type Result from './result.vue'

export const IconMap = {
  success: 'icon-success',
  warning: 'icon-warning',
  error: 'icon-error',
  info: 'icon-info',
  '400': '400',
  '403': '403',
  '404': '404',
  '500': '500',
  '502': '502',
  expiration: 'expiration',
  'no-open': 'no-open',
  upgrade: 'upgrade',
} as const

export const IconComponentMap: Record<
  typeof IconMap[keyof typeof IconMap],
  Component
> = {
  [IconMap.success]: WsIconSuccess,
  [IconMap.warning]: WsIconWarning,
  [IconMap.error]: WsIconError,
  [IconMap.info]: WsIconInfoFill,
  [IconMap['400']]: icon400,
  [IconMap['403']]: icon403,
  [IconMap['404']]: icon404,
  [IconMap['500']]: icon500,
  [IconMap['502']]: icon502,
  [IconMap.expiration]: iconExpiration,
  [IconMap['no-open']]: iconNoOpen,
  [IconMap.upgrade]: iconUpgrade,
}

export const resultProps = buildProps({
  /**
   * @description title of result
   */
  title: {
    type: String,
    default: '',
  },
  /**
   * @description sub title of result
   */
  subTitle: {
    type: String,
    default: '',
  },
  /**
   * @description icon type of result
   */
  icon: {
    type: String,
    values: [
      'success',
      'warning',
      'info',
      'error',
      '400',
      '403',
      '404',
      '500',
      '502',
      'expiration',
      'no-open',
      'upgrade',
    ],
    default: 'info',
  },
  /**
   * @description icon style of result
   */
  iconStyle: {
    type: Object,
    default: () => ({}),
  },
  /**
   * @description whether to fill the container
   */
  fill: {
    type: Boolean,
    default: false,
  },
  /**
   * @description direction of result
   */
  direction: {
    type: String,
    values: ['row', 'column'],
    default: '',
  },
} as const)

export type ResultProps = ExtractPropTypes<typeof resultProps>

export type ResultInstance = InstanceType<typeof Result>
